function gtag(...args) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push(...args);
  }
}

export const ENROLL_TYPE = {
  COURSE: 'CourseEnroll',
  JOURNEY: 'JourneyEnroll',
};

export const ENROLL_SOURCE = {
  MAIN: 'Main',
  ACADEMY: 'Academy',
  DETAIL: 'Detail',
  DASHBOARD: 'Dashboard',
  PERFORM: 'Perform',
  REWARDS: 'Rewards',
};

export default class GoogleAnalytics {
  static ecommercePurchase(eventName, purchaseId, price, product) {
    gtag({
      event: eventName,
      currencyCode: 'EUR',
      ecommerce: {
        purchase: {
          actionField: {
            id: purchaseId,
            revenue: price,
          },
          products: [
            {
              id: product.id,
              name: product.name,
              category: product.category,
              quantity: 1,
              price,
            },
          ],
        },
      },
    });
  }

  static courseBought(course, amount, purchaseId) {
    const price = (amount / 100).toFixed(2);
    GoogleAnalytics.ecommercePurchase('CoursePurchase', purchaseId, price, {
      id: course.inAppProduct.product,
      name: course.name,
      category: 'Course',
    });
  }

  static journeyBought(journey, amount, purchaseId) {
    const price = (amount / 100).toFixed(2);
    GoogleAnalytics.ecommercePurchase('JourneyPurchase', purchaseId, price, {
      id: journey.inAppProduct.product,
      name: journey.title,
      category: 'Journey',
    });
  }

  static certificateBought(certificate, amount, purchaseId) {
    const price = (amount / 100).toFixed(2);
    GoogleAnalytics.ecommercePurchase(
      'CertificatePurchase',
      purchaseId,
      price,
      {
        id: certificate.inAppProduct.product,
        name: certificate.course.name,
        category: 'Certificate',
      },
    );
  }

  static accountCreated(fromHeader) {
    gtag({ event: 'AccountCreate', source: fromHeader ? 'Header' : 'Enroll' });
  }

  static courseStarted(courseName) {
    gtag({ event: 'CourseStart', name: courseName });
  }

  static courseFinished(courseName) {
    gtag({ event: 'CourseFinish', name: courseName });
  }

  static enrollClicked(
    eventName,
    itemName,
    source = ENROLL_SOURCE.DETAIL,
    isLogged = true,
  ) {
    gtag({ event: eventName, name: itemName, source, isLogged });
  }

  static journeyStarted(journeyName) {
    gtag({ event: 'JourneyStart', name: journeyName });
  }

  static journeyFinished(journeyName) {
    gtag({ event: 'JourneyFinish', name: journeyName });
  }
}
